import { useState } from "react";

import { Button } from "@monorepo-apps/ui/src/components/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@monorepo-apps/ui/src/components/dialog";

import { useUpsertProduct } from "@/application/use-cases/products/use-products.queries";
import {
  ProductFormBody,
  type ProductFormValues,
} from "@/presentation/components/products/product-form-body";
import type { ProductRow } from "@/infrastructure/supabase/database.types";

interface EditProductDialogProps {
  product: ProductRow | null;
  onClose: () => void;
}

export function EditProductDialog({ product, onClose }: EditProductDialogProps) {
  return (
    <Dialog open={product !== null} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="!max-w-2xl">
        {product ? <Body product={product} onClose={onClose} /> : null}
      </DialogContent>
    </Dialog>
  );
}

function Body({ product, onClose }: { product: ProductRow; onClose: () => void }) {
  const [values, setValues] = useState<ProductFormValues | null>(null);
  const upsert = useUpsertProduct();

  const handleSave = () => {
    if (!values) {
      onClose();
      return;
    }
    upsert.mutate({ id: product.id, ...values }, { onSuccess: () => onClose() });
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>Edit product</DialogTitle>
      </DialogHeader>
      <ProductFormBody initial={product} onChange={setValues} />
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSave} disabled={upsert.isPending}>
          {upsert.isPending ? "Saving…" : "Save"}
        </Button>
      </DialogFooter>
    </>
  );
}
